"use strict";

var avatarSchema = {
  anyOf: [{
    enum: [false]
  }, {
    type: 'object',
    additionalProperties: false,
    properties: {
      name: {
        type: 'string'
      },
      image: {
        type: 'string',
        format: 'uri'
      },
      formatName: {
        type: 'string',
        pattern: 'initials|initializeFirst'
      }
    }
  }]
};
module.exports = avatarSchema;